// Offline game queues are disabled in the private self-hosted edition.
export default defineNuxtPlugin(() => {});
